import { careerProfilesApi } from 'CareerProfiles';
import { useSuspenseQuery } from 'ReduxHelpers';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { useRequiredCurrentUser } from 'FrontRoyalAngular';
import { getUserProgramState } from 'Users';
import { useGetUserChannelMap } from './useGetUserChannelMap';
import { useGetUsersAndCareerProfiles } from './useGetUsersAndCareerProfiles';
import { getNetworkContactUserId } from '../selectors';

export const useGetStudentsToMessage = () => {
    const currentUser = useRequiredCurrentUser();
    const [usersWithExistingMessages, userChannelMap] = useGetUserChannelMap();
    const networkContactUserId = useSelector(getNetworkContactUserId);

    const relevantUserIds = useMemo(
        () => [...usersWithExistingMessages, networkContactUserId].filter(v => !!v) as string[],
        [networkContactUserId, usersWithExistingMessages],
    );

    const cohortId = useMemo(() => getUserProgramState(currentUser)?.cohort?.id ?? null, [currentUser]);

    const { data: recommendedProfiles = [] } = useSuspenseQuery(
        careerProfilesApi,
        'getRecommendedClassmates',
        cohortId,
    );
    const { data: relevantUserProfiles = [] } = useSuspenseQuery(
        careerProfilesApi,
        'getAllRequiredProfilesForSendbirdInBatches',
        relevantUserIds,
    );
    const { availableUsers, suggestedUsers, profilesById } = useGetUsersAndCareerProfiles({
        recommendedProfiles,
        relevantUserProfiles,
        usersWithExistingMessages,
        currentUserId: currentUser.id,
        cohortId,
    });

    return { availableUsers, suggestedUsers, profilesById, userChannelMap };
};
